export const TABLET = 800;
